/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssistantChatPostRequestMessage } from './AssistantChatPostRequestMessage';
import {
    AssistantChatPostRequestMessageFromJSON,
    AssistantChatPostRequestMessageFromJSONTyped,
    AssistantChatPostRequestMessageToJSON,
    AssistantChatPostRequestMessageToJSONTyped,
} from './AssistantChatPostRequestMessage';

/**
 * 
 * @export
 * @interface AssistantChatPostRequest
 */
export interface AssistantChatPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequest
     */
    id: string;
    /**
     * 
     * @type {AssistantChatPostRequestMessage}
     * @memberof AssistantChatPostRequest
     */
    message: AssistantChatPostRequestMessage;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequest
     */
    conversationId?: string;
}

/**
 * Check if a given object implements the AssistantChatPostRequest interface.
 */
export function instanceOfAssistantChatPostRequest(value: object): value is AssistantChatPostRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AssistantChatPostRequestFromJSON(json: any): AssistantChatPostRequest {
    return AssistantChatPostRequestFromJSONTyped(json, false);
}

export function AssistantChatPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantChatPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'message': AssistantChatPostRequestMessageFromJSON(json['message']),
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
    };
}

export function AssistantChatPostRequestToJSON(json: any): AssistantChatPostRequest {
    return AssistantChatPostRequestToJSONTyped(json, false);
}

export function AssistantChatPostRequestToJSONTyped(value?: AssistantChatPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'message': AssistantChatPostRequestMessageToJSON(value['message']),
        'conversationId': value['conversationId'],
    };
}

